// extracted by mini-css-extract-plugin
export var arrow = "fc-carousel-module--arrow--b86fb";
export var item = "fc-carousel-module--item--300f4";
export var items = "fc-carousel-module--items--9214c";
export var next = "fc-carousel-module--next--dc8bb";
export var noTitle = "fc-carousel-module--noTitle--3aa61";
export var prev = "fc-carousel-module--prev--7a413";
export var root = "fc-carousel-module--root--14343";
export var title = "fc-carousel-module--title--3226d";
export var white = "fc-carousel-module--white--86c7a";